import * as actionTypes from './actions/actionTypes'

export default {
  [actionTypes.LOCATION_HOME]: '/',
  [actionTypes.LOCATION_VIEW_ALL_TRIPS]: '/all-trips',
  [actionTypes.LOCATION_ADD_TRIP]: '/add-trip',
  [actionTypes.LOCATION_VIEW_TRIP]: '/trip/:tripId',
  [actionTypes.LOCATION_VIEW_TRIP_AS_LIST]: '/trip-list/:tripId',
  [actionTypes.LOCATION_VIEW_TRIP_AS_MAP]: '/trip/:tripId',
  [actionTypes.LOCATION_VIEW_TRIP_EVENT]: '/trip/:tripId/:eventId',
  [actionTypes.LOCATION_VIEW_TRIP_EVENT_INFO]: '/trip/:tripId/:eventId/info',
  [actionTypes.LOCATION_VIEW_TRIP_LIST_EVENT_INFO]: '/trip-list/:tripId/:eventId/info',
  [actionTypes.LOCATION_VIEW_TRIP_EVENT_INFO_DAY_MEDIA]: '/trip/:tripId/:eventId/info/:dayNum/:mediaType/:mediaId',
  [actionTypes.LOCATION_VIEW_TRIP_LIST_EVENT_INFO_DAY_MEDIA]: '/trip-list/:tripId/:eventId/info/:dayNum/:mediaType/:mediaId',
  [actionTypes.LOCATION_EDIT_TRIP]: '/edit-trip/:tripId',
  [actionTypes.LOCATION_404]: '/404',
}



// WEBPACK FOOTER //
// ./src/redux/routesMap.js